import { makeAutoObservable, reaction, runInAction } from "mobx";
import { ITenant } from "../models/tenant";
import { RootStore } from "./rootStore";
import {
  getTenantList,
  getNativeAppConf,
  setNativeAppConf,
  getAppUser,
  updateMeeting,
  getMeetings,
  updateMeetingNodes,
  getMeetingNodes,
  updateBoard,
  updateBoardNodes,
  getMainBoard,
  getBoardNodes,
} from "../sqlite/utilities";
import { INativeAppConf } from "../models/offline";
import { history } from "../..";
import cmsThemes from "../models/theme";
import { IUser } from "../models/user";
import { IUserMeeting } from "../models/meeting";
import { toast } from "react-toastify";
import agent from "../api/agent";
import { INode } from "../models/node";
import DownloadErrorToast from "../../components/toast/DownloadErrorToast";
import DownloadCompletedToast from "../../components/toast/DownloadCompletedToast";
import { IBoardTreePageDto } from "../models/dto";

export default class OfflineStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
/*
    reaction(
      () => this.currentTenant,
      (currentTenant) => {
        if (currentTenant) {
          let theme = cmsThemes.get(currentTenant.theme);
          this.rootStore.commonStore.theme = theme
            ? theme
            : cmsThemes.get("default");
        } else {
          this.rootStore.commonStore.theme = cmsThemes.get("default");
        }
      }
    );
  */
  }

  nativeAppConf: INativeAppConf | null = null;
  user: IUser | null = null;
  tenantArray: ITenant[] | null = null;
  currentTenant: ITenant | null = null;
  directTenantAccess: string | null = null;
  meetingsArray: IUserMeeting[] | null = null;
  offlineDashboardLoaded: boolean = false;
  isChangePINOpen = false;
  treeNodes: INode[] | null = null;
  mainBoardTree: IBoardTreePageDto | null = null;
  alreadyDownloadedMeetingIds: Map<number, Date> = new Map<number, Date>();
  alreadyDownloadedBoardIds: Map<number, Date> = new Map<number, Date>();
  currentDownloadingMeetingId: number | null = null;
  currentDownloadingBoardId: number | null = null;
  // COMPUTED

  get isTokenValidOffline() {
    let isValid = false;
    try {
      // const { token } = this.rootStore.commonStore;
      // if (token) {
      //   const jwtToken = JSON.parse(atob(token.split(".")[1]));
      //   const expires = new Date(jwtToken.exp * 1000);
      //   isValid = Date.now() < expires.getTime();
      // }
    } catch (error) {
      isValid = false;
    }
    return isValid;
  }

  get isDownloadInProgress() {
    return this.currentDownloadingMeetingId || this.currentDownloadingBoardId;
  }

  // AUTHORIZATION

  loadUserFromDb = async () => {
    try {
      const user = await getAppUser();
      runInAction(() => {
        this.user = user;
      });
    } catch (error) {}
  };

  loadTenantsFromDb = async () => {
    try {
      const tenants = await getTenantList();
      runInAction(() => {
        this.tenantArray = tenants;
      });
    } catch (error) {}
  };

  loadNativeAppConfFromDb = async () => {
    try {
      const config = await getNativeAppConf();
      runInAction(() => {
        this.nativeAppConf = config;
      });
    } catch (error) {}
  };

  saveNativeAppConfToDb = async (pin?: number) => {
    try {
      const config = await setNativeAppConf(pin);
      runInAction(() => {
        this.nativeAppConf = config;
      });
      history.push("/home");
    } catch (error) {
      throw error;
    }
  };

  updatePINToDb = async (pin?: number) => {
    try {
      await setNativeAppConf(pin);
      runInAction(() => {
        this.isChangePINOpen = false;
      });
    } catch (error) {
      throw error;
    }
  };

  validateOfflinePin = (pin: number) => {
    try {
      if (this.nativeAppConf && this.nativeAppConf.pin === pin)
        history.push("/home");
      else throw new Error("PIN errato");
    } catch (error) {
      throw error;
    }
  };

  setIsChangePINOpen = (value: boolean) => {
    this.isChangePINOpen = value;
  };

  setCurrentTenant = async (path: string) => {
    let names = this.tenantArray
      ? this.tenantArray.reduce((a: string[], o) => (a.push(o.path), a), [])
      : [];
    let index = names.indexOf("/" + path);
    if (index >= 0) {
      let tenant = this.tenantArray![index];
      this.currentTenant = tenant;
      console.log("-->setCurrentTenant");
      await this.rootStore.tenantStore.cssTenantOffline(tenant);
    } else {
      history.push("/home");
    }
  };

  loadAlreadyDownloadedData = async (tenantId: number) => {
    try {
      await this.loadAlreadyDownloadedMeetings(tenantId);
      await this.loadAlreadyDownloadedBoards(tenantId);
    } catch (error) {}
  };

  setDirectTenantAccess = (path: string | null) => {
    this.directTenantAccess = path;
  }

  loadCssTheme = async (tenantId: string) => {
    try {
      //this.rootStore.commonStore.theme = cmsThemes.get("template");
      await this.setCurrentTenant(tenantId);
      
    } catch (error) {}
  };
  // MEETINGS

  saveMeetingToDb = async (meeting: IUserMeeting, tenant: ITenant) => {
    try {
      let saved = await updateMeeting(meeting, tenant);
      if (!saved) throw new Error("Error saving meeting to DB");

      const meetingTree = await agent.Meeting.nodes(meeting.id);
      if (meetingTree && meetingTree.tree)
        saved = saved && (await updateMeetingNodes(meeting, meetingTree.tree));

      if (saved)
        toast.success(
          (props) =>
            DownloadCompletedToast({
              title: meeting.title,
              toastContentProps: props,
            }),
          { toastId: `DownloadCompleted_${meeting.id}` }
        );
      else throw new Error("Error saving meeting nodes to DB");
    } catch (error) {
      toast.error(
        (props) =>
          DownloadErrorToast({
            type: "generic",
            toastContentProps: props,
          }),
        { toastId: `DownloadCompleted_${meeting.id}` }
      );
      throw error;
    }
  };

  loadMeetingsFromDb = async (tenantId: number) => {
    try {
      const meetings = await getMeetings(tenantId);
      runInAction(() => {
        this.meetingsArray = meetings;
      });
    } catch (error) {}
  };

  loadAlreadyDownloadedMeetings = async (tenantId: number) => {
    try {
      if (!this.isDownloadInProgress) {
        const meetings = await getMeetings(tenantId);
        runInAction(() => {
          this.alreadyDownloadedMeetingIds = new Map(
            meetings.map((m) => [m.id, m.lastUpdateDate])
          );
        });
      }
    } catch (error) {}
  };

  addAlreadyDownloadedMeetings = (meeting: IUserMeeting) => {
    this.alreadyDownloadedMeetingIds.set(meeting.id, meeting.lastUpdateDate);
  };

  setCurrentDownloadingMeetingId = (meetingId: number | null) => {
    this.currentDownloadingMeetingId = meetingId;
  };

  getMeeting = (meetingId: number) => {
    return this.meetingsArray?.filter((x) => x.id === meetingId)[0];
  };

  loadNodesFromDb = async (meetingId: number) => {
    try {
      const dto = await getMeetingNodes(meetingId);
      runInAction(() => {
        this.treeNodes = dto;
      });
      return dto;
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  // BOARDS

  saveBoardToDb = async (board: IBoardTreePageDto, tenant: ITenant) => {
    try {
      let saved = await updateBoardNodes(board);
      if (!saved) throw new Error("Error saving board nodes to DB");

      saved = await updateBoard(board, tenant);
      if (saved)
        toast.success(
          (props) =>
            DownloadCompletedToast({
              title: board.name,
              toastContentProps: props,
            }),
          { toastId: `DownloadCompleted_${board.boardId}` }
        );
      else throw new Error("Error saving board to DB");
    } catch (error) {
      toast.error(
        (props) =>
          DownloadErrorToast({
            type: "generic",
            toastContentProps: props,
          }),
        { toastId: `DownloadCompleted_${board.boardId}` }
      );
      throw error;
    }
  };

  loadMainBoardFromDb = async (tenantId: number) => {
    try {
      const mainBoard = await getMainBoard(tenantId);
      if (mainBoard && mainBoard.boardId) {
        const nodes = await getBoardNodes(mainBoard.boardId);
        runInAction(() => {
          const { boardId, name, canEditNodes, lastUpdateDate } = mainBoard;
          this.mainBoardTree = {
            boardId: boardId,
            name: name,
            tree: nodes,
            canEditNodes: canEditNodes,
            lastUpdateDate: lastUpdateDate,
          };
        });
      } else throw new Error("Main board not found");
    } catch (error) {
      console.log(error);
      throw error;
    }
  };

  setCurrentDownloadingBoardId = (boardId: number | null) => {
    this.currentDownloadingBoardId = boardId;
  };

  addAlreadyDownloadedBoards = (board: IBoardTreePageDto) => {
    if (board.lastUpdateDate)
      this.alreadyDownloadedBoardIds.set(board.boardId, board.lastUpdateDate);
  };

  loadAlreadyDownloadedBoards = async (tenantId: number) => {
    try {
      if (!this.isDownloadInProgress) {
        const board = await getMainBoard(tenantId);
        if (board && board.lastUpdateDate)
          runInAction(
            () =>
              (this.alreadyDownloadedBoardIds = new Map([
                [board.boardId, board.lastUpdateDate!],
              ]))
          );
      }
    } catch (error) {}
  };

  // CLEANUP

  offlineLogout = async () => {
    this.user = null;
    this.tenantArray = null;
    this.currentTenant = null;
    this.offlineDashboardLoaded = false;
    // this.rootStore.commonStore.setToken(null);

    history.push("/offline");
  };

  setOfflineDashboardLoaded = () => {
    this.offlineDashboardLoaded = true;
  };

  resetNativeAppConf = () => {
    this.nativeAppConf = null;
  };

  resetNodeTree = () => {
    this.treeNodes = null;
  };
}
